import classnamesBind from 'classnames/bind';
import PropTypes from 'prop-types';
import { withThemeStyles } from '@concur/ui-theming';
import React from 'react';
import withNuiFormatter from '../utils/withNuiFormatter';
import * as styles from './InlineError-*.css';

const CSS_BLOCK = 'sapcnqr-inline-error';

const InlineError = (props) => {
    const {
        className,
        classNameMap,
        correlationId,
        formatter,
        message,
        messageClassName,
    } = props;

    const classnames = classnamesBind.bind(classNameMap);

    const classes = classnames(CSS_BLOCK, className);

    return (
        <div className={classes}>
            <div className={classnames(`${CSS_BLOCK}__error-message`, messageClassName)}>
                {message || formatter.formattedMessage({ id: 'CoreUI.errorPage_ServerError.header' })}
            </div>
            {correlationId && (
                <div className={classnames(`${CSS_BLOCK}__error-description`, messageClassName)}>
                    {formatter.formattedMessage({ id: 'CoreUI.error.correlationid', values: { correlationId } })}
                </div>
            )}
        </div>
    );
};

InlineError.displayName = 'InlineError';

InlineError.propTypes = {
    className: PropTypes.string,
    correlationId: PropTypes.string,
    message: PropTypes.string,
    messageClassName: PropTypes.string,
};

export default withThemeStyles(withNuiFormatter(InlineError), styles);
